import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { HotToastService } from '@ngxpert/hot-toast';

import { SasButtonComponent } from "@shared/sas-button/sas-button.component";
import { FormSubmittedService } from '@shared/services/form-submitted.service';

@Component({
    selector: 'sas-dynamic-form',
    standalone: true,
    imports: [FormlyModule, ReactiveFormsModule, SasButtonComponent],
    providers: [],
    templateUrl: './sas-dynamic-form.component.html',
    styleUrl: './sas-dynamic-form.component.scss'
})
export class SasDynamicFormComponent {
    notification = inject(HotToastService);
    formSubmittedService = inject(FormSubmittedService);
    //formName = input('', { transform: this.trimString });
    //schema = input.required({ alias: 'fields' });
    //sasModel = input.required<any>;
    //type = input<string>;
    //text? = input<string>;
    //topButton? = input<boolean>;
    //extraButtonText = input<string>;
    //readMode? = input<boolean>;
    //extraButton? = output<any>();
    //onSubmit? = output<any>();

    @Input() formName: string = 'sasDynamicForm';
    @Input() schema: any;
    @Input() sasModel!: any;
    @Input() text?: string;
    @Input() topButton?: boolean;
    @Input() extraButtonText?: string;
    @Input() readMode?: boolean = false;
    @Output() sasOnSubmit = new EventEmitter<any>();
    @Output() extraButton = new EventEmitter<any>();

    formMain = new FormGroup({});
    formFields!: FormlyFieldConfig[];
    initialModel: any = {};
    hideReset: boolean = false;
    options: FormlyFormOptions = {
        formState: {
            //lang: $translate.use(),
            readMode: this.readMode
        },
        //resetModel: this.resetModel,    // review if neeeded
        //updateInitialValue: this.updateInitialModel  // review if neeeded
    };
    name: string = '';

    ngOnInit() {
        if (this.schema === undefined || this.schema === null) {
            this.schema = [];
            console.error(`Schema not provided to ${this.formName}`);
        }
        else {
            this.formFields = this.mapSchema(this.schema);
        }
        this.initialModel = { ...this.sasModel };
        //this.name = this.formName() ?? 'sasDynamicForm';
        //ctrl.hideReset = false;  --> is this to handle if show or not the reset button. Then it should be a parameter
    }

    onFormModelChange() {
        //console.log('formly modelchange event fired')
    }

    actionForm() {
        this.formSubmittedService.setSubmitted(true);

        if (this.formMain.valid) {
            this.sasOnSubmit.emit(this.sasModel)
            this.formSubmittedService.setSubmitted(false);
        }
        else {
            const message = `<span class='sas-message-warning'>Form not completed. <br> You need to fill all the mandatory fields (*) before submitting</span>`;
            this.notification.warning(message);
        }
    }

    extraButtonAction(ev: Event) {
        if (this.extraButton !== undefined) {
            this.extraButton.emit({ event: ev });
        }
    };

    resetModel() {
        this.sasModel = Object.assign({}, this.initialModel);
        this.formMain.setValue(this.initialModel)
        this.formSubmittedService.setSubmitted(false);
        this.formMain.markAsPristine();
    }

    updateInitialModel() {

    }

    mapSchema(schemaInput: any): any {
        const schema = (typeof schemaInput === 'string') ? JSON.parse(schemaInput) : schemaInput;
        const outputSchema = schema[0].fieldGroup !== undefined ? schema[0].fieldGroup : schema;
        let formFields = [];

        if (schema[0].fieldGroup !== undefined) {
            formFields = outputSchema.map((field: any) => {
                switch (field.type) {
                    case 'sasInput':
                        return this.mapInput(field);
                    case 'sasInputMail':
                        return this.mapInputEmail(field);
                    case 'sasSelect':
                        return this.mapSelect(field);
                    case 'sasCheckbox':
                        return this.mapCheckbox(field);
                    case 'sasTextarea':
                        return this.mapTextarea(field);
                    default:
                        return field
                }
            });
        }
        else {
            formFields = outputSchema;
        }
        return JSON.parse(JSON.stringify(formFields));
    }

    private mapInput(field: any) {
        return {
            key: field.key,
            type: 'sasInput',
            id: field.id,
            name: field.name,
            props: {
                label: this.cleanTranslate(field.expressionProperties['templateOptions.label']) ?? this.cleanTranslate(field.templateOptions.label),
                helptext: this.cleanTranslate(field.templateOptions.helptext),
                placeholder: this.cleanTranslate(field.expressionProperties['templateOptions.placeholder']) ?? this.cleanTranslate(field.templateOptions.placeholder),
                maxLength: field.templateOptions.maxLength,
                readonly: field.templateOptions.sasReadonly,
                required: field.templateOptions.validation.validation.required,
                validation: {
                    requiredText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.requiredText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.requiredText),
                    pattern: field.templateOptions.validation.pattern,
                    patternText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.patternText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.patternText)
                },
            }
        }
    }

    private mapInputEmail(field: any) {
        return {
            key: field.key,
            type: 'sasInputMail',
            id: field.id,
            name: field.name,
            props: {
                label: this.cleanTranslate(field.expressionProperties['templateOptions.label']) ?? this.cleanTranslate(field.templateOptions.label),
                helptext: this.cleanTranslate(field.templateOptions.helptext),
                placeholder: this.cleanTranslate(field.expressionProperties['templateOptions.placeholder']) ?? this.cleanTranslate(field.templateOptions.placeholder),
                maxLength: field.templateOptions.maxLength,
                readonly: field.templateOptions.sasReadonly,
                required: field.templateOptions.validation.validation.required,
                validation: {
                    requiredText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.requiredText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.requiredText),
                    patternText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.patternText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.patternText)
                },
            }
        }
    }

    private mapSelect(field: any) {
        return {
            key: field.key,
            type: 'sasSelect',
            id: field.id,
            name: field.name,
            props: {
                label: this.cleanTranslate(field.expressionProperties['templateOptions.label']) ?? this.cleanTranslate(field.templateOptions.label),
                placeholder: this.cleanTranslate(field.expressionProperties['templateOptions.placeholder']) ?? this.cleanTranslate(field.templateOptions.placeholder),
                helptext: this.cleanTranslate(field.expressionProperties['templateOptions.helptext']) ?? this.cleanTranslate(field.templateOptions.helptext),
                valueProp: field.templateOptions.valueProp,
                labelProp: field.templateOptions.labelProp,
                defaultText: this.cleanTranslate(field.expressionProperties['templateOptions.defaultText']) ?? this.cleanTranslate(field.templateOptions.defaultText),
                required: field.templateOptions.validation.validation.required,
                dataSource: field.templateOptions.dataSource,
                sasOptions: field.templateOptions.options,
                validation: {
                    requiredText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.requiredText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.requiredText)
                },
            }
        }
    }

    private mapCheckbox(field: any) {
        return {
            key: field.key,
            type: 'sasCheckbox',
            id: field.id,
            name: field.name,
            defaultValue: field.defaultValue,
            props: {
                label: this.cleanTranslate(field.expressionProperties['templateOptions.label']) ?? this.cleanTranslate(field.templateOptions.label),
                helptext: this.cleanTranslate(field.templateOptions.helptext),
                required: field.templateOptions.validation.validation.required,
                validation: {
                    requiredText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.requiredText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.requiredText)
                },
            }
        }
    }

    private mapTextarea(field: any) {
        return {
            key: field.key,
            type: 'sasTextarea',
            id: field.id,
            name: field.name,
            props: {
                label: this.cleanTranslate(field.expressionProperties['templateOptions.label']) ?? this.cleanTranslate(field.templateOptions.label),
                helptext: this.cleanTranslate(field.templateOptions.helptext),
                placeholder: this.cleanTranslate(field.expressionProperties['templateOptions.placeholder']) ?? this.cleanTranslate(field.templateOptions.placeholder),
                maxLength: field.templateOptions.maxLength,
                required: field.templateOptions.validation.validation.required,
                readonly: field.templateOptions.sasReadonly,
                validation: {
                    requiredText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.requiredText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.requiredText),
                    pattern: field.templateOptions.validation.pattern,
                    patternText: this.cleanTranslate(field.expressionProperties['templateOptions.validation.validation.patternText']) ?? this.cleanTranslate(field.templateOptions.validation.validation.patternText)
                },
            }
        }
    }

    private cleanTranslate(text: string) {
        return text?.replace(/["|]\s*\|\s*translate/g, '').replace(/"/g, '');
    }

    trimString(value: string | undefined): string { return value?.trim() ?? ''; }
}
